import type { HTMLAttributes } from 'react';
import { cx } from './utils';

export interface AdminBadgeProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: 'neutral' | 'admin' | 'localizator' | 'success' | 'warning' | 'danger' | 'info';
}

export function AdminBadge({ className, tone = 'neutral', ...props }: AdminBadgeProps) {
  return <span className={cx('ui-admin-badge', `ui-admin-badge--${tone}`, className)} {...props} />;
}
